import { render, staticRenderFns } from "./game.vue?vue&type=template&id=e6e4ee7a&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "./game.vue?vue&type=style&index=0&id=e6e4ee7a&prod&scoped=true&lang=scss"
import style1 from "./game.vue?vue&type=style&index=1&id=e6e4ee7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e4ee7a",
  null
  
)

export default component.exports